module.exports = __webpack_public_path__ + "img/diaTecnicoEsc.3d8bfbe7.jpg";